<h2 class="title">
  @if (isEditing) {
    <div class="custom-form-row">
      <input
        type="text"
        class="edit-title"
        [(ngModel)]="draft"
        [maxlength]="maxLength"
        (keyup.enter)="save()" />
      <ng-casto-btn class="blue smaller save" [label]="'2d-configurator.save' | translate" (click)="save()"></ng-casto-btn>
    </div>
  } @else {
    <span class="title-text">
      {{ title }}
      @if (!disabled) {
        <svg class="icon-action-edit" (click)="startEditing()">
          <use xlink:href="assets/img/icons.svg#icon-action-edit"></use>
        </svg>
      }
    </span>
  }
</h2>
